import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useState, useRef, useEffect } from 'react'
import styled from 'styled-components'
import Snowfall from 'react-snowfall'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'
import branches from './images/branches-blank.png'

const Wrapper = styled.div<{
  colorMode?: 'dark' | 'light'
  effect?: 'snowfall' | undefined
  height: number
}>`
  display: flex;
  position: relative;
  justify-content: center;
  height: ${(props) => props.height}px;
  margin-bottom: 30px;
  @media (min-width: 1200px) {
    margin: 0 -400px 30px -400px;
  }
`
const Content = styled.div`
  z-index: 200;
`
const Gradient = styled.div<{
  colorMode?: 'dark' | 'light'
  effect?: 'snowfall' | undefined
}>`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    ${(props) => (props.colorMode === 'dark' ? '#282c34' : '#efece0')} 100%
  );
  position: absolute;
  top: 0;
  left: 0;
  z-index: 50;
`
const Background = styled.div<{
  colorMode?: 'dark' | 'light'
  effect?: 'snowfall' | undefined
}>`
  width: 100%;
  height: 100%;
  // border: 1px dashed green;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  ${(props) =>
    props.effect === 'snowfall' ? `background-image: url(${branches});` : ''}
  background-repeat: repeat-x;
  background-position: bottom;
`
const Head = styled.div<{ isInApp: boolean }>`
  font-size: 3.3rem;
  color: var(--text-color);
  max-width: 668px;
  width: 100%;
  @media (max-width: 668px) {
    width: 80%;
    max-width: none;
  }
  margin: 0 2rem 4rem;
  ${(props) => (props.isInApp ? `margin-top: 2rem;` : '')}
  text-size-adjust: 100%;
`
const TitleHeader = styled.span<{ tenantKey?: string; isFree?: boolean }>`
  display: inline-block;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  text-size-adjust: 100%;
  font-weight: 600;
  color: ${(props) =>
    props.tenantKey
      ? 'var(--tenant-' + props.tenantKey + ')'
      : 'var(--tenant-tagesanzeiger)'};
  @media (prefers-color-scheme: dark) {
    color: var(--gray-5);
  }

  line-height: 2rem;
  margin-bottom: 0.3rem;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  &::before {
    background-color: ${(props) =>
      props.tenantKey
        ? 'var(--tenant-' + props.tenantKey + ')'
        : 'var(--tenant-tagesanzeiger)'};
    display: ${(props) => (props.isFree ? 'none' : 'inline-block')};
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: white;
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    content: 'Abo';
  }
  /* margin-right: 4ch; */
`
const HiddenDash = styled.span`
  display: none;
`
const TitleText = styled.span`
  font-family: var(--font-source);

  @media (min-width: 541px) {
    font-size: 4.9rem;
    line-height: 5.2rem;
  }
  font-weight: 600;
  font-size: 3.3rem;
  line-height: 3.8rem;
`
const Title = styled.h2<{ tenantKey?: string }>`
  text-size-adjust: 100%;
  margin-top: 0.3rem;
  margin-bottom: 1.2rem;
  font-size: 10px;
`
const Lead = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  line-height: 2.9rem;
  font-size: 2rem;
  margin-bottom: 4rem;
`
const Authors = styled.div`
  color: var(--text-color);
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  line-height: 1.8rem;
  border-top: 1px solid var(--border-color);
  margin-right: 1rem;
  padding-top: 2rem;
  a {
    color: var(--text-color);
    text-decoration: none;
    border-bottom: 1px solid var(--text-color);
  }
  span::after {
    content: ', ';
  }
  span:last-child::after {
    content: '';
  }
`

const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
  properties,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const [isInApp, setIsInApp] = useState(false)
  const wrapperHeight = properties?.height ? properties?.height : 600

  return (
    <Wrapper className={globalClasses.join(' ')} height={wrapperHeight}>
      {/* {properties?.effect === 'snowfall' && (
        <Snowfall style={{ height: snowfallHeight + 'px' }} />
      )} */}
      <Content>
        <Head isInApp={isInApp}>
          <Title tenantKey={tenant?.key}>
            <TitleHeader isFree={properties?.isFree} tenantKey={tenant?.key}>
              {properties?.heading || 'Please pass a heading to the component'}
            </TitleHeader>
            <HiddenDash aria-hidden='true' role='presentation'>
              {' '}
              –{' '}
            </HiddenDash>
            <TitleText>
              {properties?.title || 'Please pass a title to the component'}
            </TitleText>
          </Title>
          <Lead>
            {properties?.lead || 'Please pass a lead to the component'}
          </Lead>
          {properties?.authors && (
            <Authors>
              {properties?.authors.split(', ').map((m, i) => {
                let parts = m.split('[')
                console.log(parts)
                let name = parts[0]
                let unityId = parts[1] && parts[1].replace(']', '')
                if (!unityId) return <span key={name}>{name}</span>
                return (
                  <span key={unityId}>
                    <a
                      href={`https://www.${tenant?.key}.ch/author/${unityId}/${name}`}
                    >
                      {name}
                    </a>
                  </span>
                )
              })}
            </Authors>
          )}
        </Head>
      </Content>
      <Background effect='snowfall' colorMode={colorMode}>
        <Snowfall style={{ height: wrapperHeight + 'px' }} />
      </Background>
      <Gradient colorMode={colorMode} />
    </Wrapper>
  )
}

export default MainComponent
